"use client"
import Link from "next/link";
import Image from "next/image";
import { useState } from "react";
import { ICampaign } from "@/interface";

const MENU = [
  { label: "Trang chủ", href: "#home" },
  { label: "Thể lệ", href: "#rule" },
  { label: "Danh sách tham gia", href: "#join-list" },
  { label: "Danh sách trúng thưởng", href: "#winner-list" },
];  

export default function Header({ campaign }: { campaign: ICampaign }) {
  const [active, setActive] = useState("#home");

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white">
      <div className="container md:max-w-6xl mx-auto px-3 lg:px-8">
        <div className="flex items-center justify-between py-5 gap-4">
          <Link href="#home">
            <Image src={campaign?.logo?.url || "/logo-toshiba.png"} alt="Logo" width={70} height={70} className="object-contain " />
          </Link>
          <div className="md:flex items-center gap-12 hidden">
            {MENU.map((item) => {
              return (
                <Link
                  key={item.href}
                  href={item.href}
                  className={`text-lg transition-colors hover:text-red-600 ${active === item.href ? "font-bold text-red-600" : ""}`}
                  onClick={() => setActive(item.href)}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>
          <div className="flex items-center gap-2">
            <Link
              href="/join-game"
              className="text-xl h-[54px] w-[200px] font-semibold flex items-center justify-center"
              style={{
                backgroundColor: "var(--button-primary)",
                color: "white",
              }}
            >
              Mở Quà Ngay
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
